import { render, staticRenderFns } from "./QuestionText.vue?vue&type=template&id=6578c406&scoped=true&"
import script from "./QuestionText.vue?vue&type=script&lang=ts&"
export * from "./QuestionText.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionText.vue?vue&type=style&index=0&id=6578c406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6578c406",
  null
  
)

export default component.exports